import { MARKETPLACE_ONBOARDING_ERROR_PARAMS, MARKETPLACE_ONBOARDING_SETTINGS, } from './marketplace-onboarding-params.js';
const isMarketplaceOnboardingSettings = (value) => MARKETPLACE_ONBOARDING_SETTINGS.includes(value);
export const marketplaceOnboardingHandler = {
    pathPattern: '/brands/:brandId/home',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/home` }),
    // Brand-scoped: the OAuth callback carries no location and the marketplace
    // settings routes take none, so a location-less return still resolves.
    scopedToLocation: false,
    // Only a callback carrying a known `settings` token resolves inbound. A bare
    // /brands/:brandId/home — and an unrecognised token — stays unresolved, so
    // no unroutable native path is ever produced.
    resolve: (pathParams, query) => {
        const settings = query.get('settings');
        if (!settings || !isMarketplaceOnboardingSettings(settings))
            return null;
        const errorCode = query.get(MARKETPLACE_ONBOARDING_ERROR_PARAMS[settings]) ?? undefined;
        return {
            key: 'marketplace-onboarding',
            params: {
                brandId: pathParams.brandId,
                settings,
                ...(errorCode ? { errorCode } : {}),
            },
        };
    },
    // `resolveInbound` keeps only the handler's params, so the error code rides
    // on them and is re-emitted here rather than reconstructed by the client.
    toNative: ({ brandId, errorCode, settings }) => {
        const settingsRoot = `/brands/${brandId}/settings`;
        if (!settings)
            return settingsRoot;
        const route = `${settingsRoot}/${settings}`;
        if (!errorCode)
            return route;
        const param = MARKETPLACE_ONBOARDING_ERROR_PARAMS[settings];
        return `${route}?${param}=${encodeURIComponent(errorCode)}`;
    },
    meta: {
        title: 'Marketplace onboarding',
        description: 'Opens brand home with a marketplace onboarding settings panel (via ?settings=).',
        status: 'live',
        platforms: { web: true, ios: true, android: true },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'settings', in: 'query', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            query: { settings: 'brand.marketplaces.grubhub' },
        },
    },
};
//# sourceMappingURL=marketplace-onboarding.js.map